export enum CELL_FILTER {
  // eslint-disable-next-line id-blacklist
  string = 'stringFilter',
  date = 'dateFilter',
  dateTime = 'dateTimeFilterI18n',
  enum = 'enumFilter',
  entity = 'entityFilter',
  dateLocale = 'dateFilterI18n',
}
